<template>
  <div class="index">
    <div class="middle-main" v-if="isPc != 3">
      <div class="banner-swiper">
        <el-row :gutter="isPc ? 30 : 0">
          <el-col :span="isPc ? 16 : 24">
            <div v-for="(item, index) in newsListRes.slice(0, 4)" :key="item.newsId">
              <news-item :item="item" :imgSize="index === 0 ? 'big' : 'small'"
                :direction="index !== 0 ? 'row' : 'col'" />
              <div class="line" v-if="index === 0"></div>
            </div>
          </el-col>
          <el-col :span="isPc ? 8 : 24">
            <div v-for="(item, index) in newsListRes.slice(4, 9)" :key="item.newsId">
              <news-item :item="item" :direction="index !== 0 ? 'row' : 'col'" :showImg="index === 0" />
              <div class="line" v-if="index !== 4"></div>
            </div>
          </el-col>
        </el-row>
        <div class="line" style="margin-top: 60px;"></div>
      </div>
      <!-- 杂志 -->
      <div class="magazine" v-if="magazineListRes.length > 0" @click="fnToMagazine(magazineListRes[0].mgzId)">
        <book-animation class="book-animation" :magazineList="magazineListRes" />
        <div class="magazine-content">
          <div class="title">
            <h3>
              {{ magazineListRes[0].title }}
              <div class="magazine-info">
                <span>最新</span>
                <time>{{ magazineListRes[0].releaseTime }} 發布</time>
              </div>
            </h3>
            <span class="font14 more flex items-center" @click="toMore('/magazine')">
              更多台商月刊
              <svg-icon icon-class="arrow-right" color="#AEAEB2" /></span>
          </div>
          <p v-html="magazineListRes[0].content"></p>
        </div>

      </div>
      <!-- 智库专栏和故事专访 -->
      <div class="library-story">
        <div class="library-column">
          <div class="title">
            <h3><svg-icon icon-class="library-column" color="#2C2C2E" /> {{L('智库专栏')}}</h3>
            <span class="font14 more" @click="toMore('/expert')">{{L('查看更多')}} <svg-icon icon-class="arrow-right"
                color="#AEAEB2" /></span>
          </div>
          <el-row :gutter="isPc ? 20 : 0">
            <el-col :span="isPc ? 12 : 24">
              <vue-seamless-scroll :data="libraryListRes.slice(0, 6)" :class-option="optionSingleHeightTimeup"
                class="seamless-warp" style="height: 1000px;overflow: hidden;">
                <library-item v-for="item in libraryListRes.slice(0, 6)" :key="item.newsId + ''" :item="item" />
              </vue-seamless-scroll>
            </el-col>
            <el-col :span="isPc ? 12 : 24">
              <vue-seamless-scroll :data="libraryListRes.slice(6, 12)" :class-option="optionSingleHeightTimeup"
                class="seamless-warp" style="height: 1000px;overflow: hidden;">
                <library-item v-for="item in libraryListRes.slice(6, 12)" :key="item.newsId + ''" :item="item" />
              </vue-seamless-scroll>
            </el-col>
          </el-row>
          <div class="line" style="margin-top: 0;"></div>
        </div>
        <div class="story-interview">
          <div class="title">
            <h3><svg-icon icon-class="story-interview" color="#2C2C2E" /> {{L('故事專訪')}}</h3>
            <span class="font14" @click="toMore('/story?typeId=14')">{{L('查看更多')}} <svg-icon icon-class="arrow-right"
                color="#AEAEB2" /></span>
          </div>
          <swiper-policy typeId="14" />
        </div>
      </div>
      <!-- 杂志订阅 -->
      <div class="magazine-subscription">
        <magazine-order-info :magazineList="magazineListRes" />
      </div>


      <column-title :title="L('視頻影音')" path="/video?typeId=15" />
      <div class="video-list">
        <el-row :gutter="isPc ? 20 : 0">
          <el-col :span="isPc ? 8 : 12" v-for="item in videoListRes" :key="item.newsId">
            <video-item :video="item" />
          </el-col>
        </el-row>
      </div>
      <column-title :title="L('政策指引')" path="/article?typeId=17" />
      <div class="policy-list justify-between ">
        <div style="flex: 1;">
          <policy-item v-for="item in policyListRes.slice(0, 4)" :key="item.id" :policy="item" />
        </div>
        <div class="line-col"></div>
        <div style="flex: 1;">
          <policy-item v-for="item in policyListRes.slice(4, 8)" :key="item.newsId" :policy="item" />
        </div>
      </div>
      <div class="line" style="margin-top: 80px;"></div>
      <column-title :title="L('好書推薦')" path="/book" />
      <swiper-book />
    </div>
    <div v-else>
      <div class="banner-swiper" style="padding: 20px;">
        <div v-for="(item, index) in newsListRes" :key="item.newsId">
          <video-item :video="item" v-if="item.typeId == 15" />
          <news-item :item="item" direction="col" v-else />
          <div class="line"></div>
        </div>
        <div class="loading-tips">{{ isLoading ? L('加载中...') : L('暂无更多数据。。。') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import newsItem from "../common/news-item.vue";
import bookAnimation from "../common/book-animation.vue";
import libraryItem from "../common/library-item.vue";
import magazineOrderInfo from "../common/magazine-order-info.vue";
import videoItem from "../common/video-item.vue";
import policyItem from "../common/policy-item.vue";
import newsList from "../common/news-list.vue";
import swiperPolicy from "../common/swiper-policy.vue";
import tabs from "../common/tabs.vue";
import swiperBook from "../common/swiper-book.vue";
import { mapState } from "vuex";
import ColumnTitle from "../common/column-title.vue";
import bookList from "../common/book-list.vue";
import { getNewsList, getTagList } from "@/assets/api/news.js";
import { getMagazineList } from "@/assets/api/magazine.js";
import HotItem from "../common/hot-item.vue";
import Vue from "vue";
import axios from "axios";
axios.defaults.baseURL = "/gdWeather";
export default {
  name: 'home',

  components: {
    newsItem,
    bookAnimation,
    videoItem,
    policyItem,
    magazineOrderInfo,
    libraryItem,
    ColumnTitle,
    swiperPolicy,
    swiperBook,
  },

  data() {
    return {
      newsListRes: [],
      libraryListRes: [],
      videoListRes: [],
      policyListRes: [],
      magazineListRes: [],
      pageNum: 1,
      isLoading: true,
    };
  },
  computed: {
    ...mapState(["isPc"]),
    optionSingleHeightTimeup() {
      return {
        // singleHeight: 26,
        // waitTime: 2500,

        step: .3, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 21, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0 // 单步运动停止的时间(默认值1000ms)

      }
    },
    optionSingleHeightTimedown() {
      return {
        // singleHeight: 26,
        // waitTime: 2500,

        step: .3, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 0, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 21, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0 // 单步运动停止的时间(默认值1000ms)

      }
    },
  },
  watch: {
    // $route() {
    //   this.$router.go();
    // },
  },
  created() {
    this.init();

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    init() {
      this.getAllTypeNewsList()
      //智库专栏
      getNewsList({
        orderByColumn: "tips",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 12,
        slideshow: 0,
        typeId: 19
      }).then((res) => {
        this.libraryListRes = res.data.rows.map((item) => {
          item.author=item.authorV2?item.authorV2:item.author;
          item.authorAvatar=item.authorAvatarV2?item.authorAvatarV2:item.authorAvatar;
          item.authorAvatar = item.authorAvatar ? !/^http/.test(item.authorAvatar)
            ? this.$imgUrl + item.authorAvatar
            : item.authorAvatar : '';
          return item;
        });
      });

      //视频影音
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: "15",
        pageNum: 1,
        pageSize: 6,
      }).then((res) => {
        this.videoListRes = res.data.rows.map((item) => {
          item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage : '';
          return item;
        });
      });
      //政策指引
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: "17",
        pageNum: 1,
        pageSize: 8,
      }).then((res) => {
        this.policyListRes = res.data.rows.map((item) => {
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
      });
      let data = {
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 3,
        goodsTypeDict: 1,
      }
      const formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }
      getMagazineList(formData).then((res) => {
        this.magazineListRes = res.data.rows.map((item) => {
          item.image = item.image ? !/^http/.test(item.image)
            ? this.$imgUrl + item.image
            : item.image : '';
          return item;
        });
      });
    },
    getAllTypeNewsList() {
      //新闻资讯
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: '',
        pageNum: this.pageNum,
        pageSize: 9,
        slideshow: 0,
      }).then((res) => {
        let arr = res.data.rows.map((item) => {
          item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage : '';
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
        console.log(res.data.rows.length > 9)
        this.isLoading = res.data.rows.length < 9 ? false : true;
        this.newsListRes = [...this.newsListRes, ...arr]
      });
    },
    fnToMagazine(mgzId) {
      this.$router.push({
        path: `/magazine-details/${mgzId}`,
      });
    },
    toMore(path = '') {
      this.$router.push({
        path: `${path}`,
      });
    },
    checkScrollBottom() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      return scrollTop + windowHeight >= documentHeight;
    },
    handleScroll() {
      if (this.isPc == 3 && this.isLoading) {
        if (this.checkScrollBottom()) {
          console.log('页面已滚动到底部');
          // 在这里可以添加更多逻辑，比如加载更多内容
          this.pageNum++;
          this.getAllTypeNewsList();
        }
      }

    }
  },
};
</script>

<style lang="less" scoped>
.line {
  width: 100%;
  height: 1px;
  background-color: #E5E5EA;
  margin: 20px 0;
}

.line-col {
  width: 1px;
  height: auto;
  background-color: #E5E5EA;
  margin: 0 30px;
}

.index {
  padding-top: 80px;
  padding-bottom: 58px;
}

.magazine {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -70px;
  cursor: pointer;

  .book-animation {
    transform: rotate(-10deg) scale(0.85) translate(40px, 50px);
    width: 321px;
    height: 270px;
    margin-right: 38px;
    position: relative;
    z-index: 99;
  }

  .magazine-content {
    flex: 1;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      h3 {
        margin-top: 0;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 32px;
        color: #E2291E;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .magazine-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 6px;

          span {
            width: 32px;
            height: 15px;
            background: #E2291E;
            border-radius: 8px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 10px;
            color: #FFFFFF;
            line-height: 15px;
            text-align: center;
            font-style: normal;

          }

          time {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #2C2C2E;
            line-height: 19px;
            text-align: left;
            font-style: normal;
          }
        }
      }

      .more {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 16px;
        text-align: right;
        font-style: normal;
        cursor: pointer;

        .svg-icon {
          margin-left: 8px;
          width: 16px;
          height: 16px;
        }
      }

      .more:hover {
        color: #E2291E;

        .svg-icon {
          color: #E2291E !important;
        }
      }

    }

    p {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 18px;
      color: #2C2C2E;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }
}

.library-story {
  background: #F2F2F7;
  border-radius: 24px;
  margin-bottom: 20px;

  .library-column {
    padding-left: 39px;
    padding-right: 51px;
    position: relative;

    .title {
      padding: 10px 0;

      h3 {
        left: 30%;
        bottom: -100%;
      }
    }

    .line {
      margin: 0;
      position: relative;
      z-index: 9;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 200px;
      background: linear-gradient(180deg, #FFFFFF 0%, rgba(242, 242, 247, 0) 100%);
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 36px;
      transform: rotate(180deg);
      background: linear-gradient(180deg, #F2F2F7 0%, rgba(242, 242, 247, 0) 100%);
    }
  }

  .title {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 29px 50px;
    position: relative;
    z-index: 9;

    h3 {
      position: absolute;
      left: 40px;
      bottom: -12px;
      z-index: 999;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 24px;
      color: #2C2C2E;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FFFFFF;
      box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.2);
      border-radius: 34px;
      width: 182px;
      height: 60px;

      .svg-icon {
        width: 32px;
        height: 32px;
        margin-right: 6px;
      }
    }

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #AEAEB2;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      cursor: pointer;

      .svg-icon {
        margin-left: 4px;
        width: 16px;
        height: 16px;
      }
    }

    span:hover {
      color: #E2291E;

      .svg-icon {
        color: #E2291E !important;
      }
    }
  }
}



.swiper-box {
  width: 825px;
  height: 518px;
  position: relative;

  .swiper-container {
    height: 100%;
  }

  .news-item {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .news-info {
      position: absolute;
      width: 100%;
      height: 100%;
      padding: 0 35px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, .35);

      h3 {
        font-family: NotoSansCJKTC;
        font-weight: 500;
        letter-spacing: 2px;
        margin-bottom: 13px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      p {
        font-family: NotoSansCJKTC;
        line-height: 1.71;
        letter-spacing: 1.4px;
      }

      .more {
        width: fit-content;
        padding: 5px 11px 5px 18px;
        border-radius: 11.5px;
        margin-top: 18px;
        font-family: NotoSansCJKTC;
        line-height: 15px;

        .svg-icon {
          width: 4px;
          height: 6px;
          margin-left: 16px;
        }
      }
    }
  }
}

.news-lists {
  flex: 1;

  .news-litem {
    padding: 4px 12px 4px 4px;
    border-bottom: 1px solid #edeff1;

    img {
      width: 118px;
      height: 118px;
      object-fit: cover;
      margin: 0 27px 0 0;
    }

    .title {
      flex: 1;

      span {
        padding: 2.1px 9.3px 2.7px 9px;
      }

      h3 {
        margin-top: 9px;
        font-weight: bold;
        font-family: NotoSansCJKTC;
        line-height: 1.5;
        letter-spacing: 0.8px;
      }
    }

    .svg-icon {
      width: 6px;
      height: 7px;
      margin-left: 22px;
    }
  }

  .news-bottom {
    padding: 16px;

    h2 {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.75;
      letter-spacing: 0.6px;
    }

    .news-bottom-left {
      width: 264px;
      margin-right: 27px;

      h2 {
        border-bottom: 1px solid #fff;
        padding-bottom: 10px;
        margin-bottom: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-weight: bold;
        line-height: 2;
        letter-spacing: 0.5px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        line-height: 1.67;
        letter-spacing: 0.6px;
        margin-top: -1px;
        height: 40px;
      }
    }

    .news-bottom-right {
      .weather {
        font-size: 18px;
        font-weight: bold;

        img {
          width: 80px;
          height: 80px;
          object-fit: contain;
          margin-right: 10px;
        }
      }
    }
  }
}

.tea {
  width: 100%;
  max-width: 970px;
  height: auto;
  margin: 30px auto;
  display: block;
}

.policy {
  position: relative;

  .more {
    padding: 10px 30px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    border-width: 2px;
    border-radius: 45px;
    margin-top: 33px;
    margin-bottom: 80px;

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.8px;
      color: #630106;
    }

    .svg-icon {
      width: 5.1px;
      height: 10.1px;
    }
  }
}

.hot-topic {
  .news-item {
    padding: 15px 18px 14px 15px;
    background-color: #fff;
    margin-top: 20px;

    img {
      width: 113px;
      height: 111px;
      object-fit: cover;
      margin-right: 17px;
    }

    time {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.71;
      letter-spacing: 0.7px;
    }

    h3 {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.88;
      letter-spacing: 2.4px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      margin-top: 6px;
    }
  }
}

.swiper-button-prev1 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);
  transform: translateY(-50%) rotate(180deg);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.swiper-button-next1 {
  right: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.my-button-disabled1 {
  background: rgba(0, 0, 0, .01);

  .svg-icon {
    color: rgba(255, 255, 255, 0.4);
  }
}

@media screen and (max-width: 768px) {

  .main,
  .min-main {
    width: 100%;
  }

  .index {
    padding-top: 0;
    padding-bottom: 20px;

    .banner-swiper {
      flex-direction: column;

      .swiper-box {
        width: 100%;
        height: 275px;
        position: relative;

        .swiper-slide,
        .swiper-container {
          width: 100% !important;
          height: 100%;
        }

        .news-item {
          position: relative;
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .news-info {
            position: absolute;
            width: 100%;
            height: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, .35);

            h3 {
              font-size: 24px;
              font-weight: 500;
              letter-spacing: 1.2px;
              margin-bottom: 5px;
            }

            p {
              font-family: NotoSansCJKTC;
              line-height: 1.71;
              letter-spacing: 1.4px;
            }

            .more {
              // transform: scale(.8);
              width: fit-content;
              padding: 4px 13px 4px 16px;
              border-radius: 11.5px;
              margin-top: 18px;
              font-family: NotoSansCJKTC;
              line-height: 15px;

              .svg-icon {
                width: 4px;
                height: 6px;
                margin-left: 16px;
              }
            }
          }
        }
      }
    }

    .news-lists {
      padding: 5px 0 0;
      flex: 1;

      .news-litem {
        padding: 5px 10px;
        border-bottom: 1px solid #edeff1;

        img {
          width: 96px;
          height: 96px;
          object-fit: cover;
          margin: 0 8px 0 0;
        }

        .title {
          flex: 1;

          span {
            padding: 2.1px 10px 3.4px 7.4px;
          }

          h3 {
            margin-top: 5px;
            font-family: NotoSansCJKTC;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: 0.8px;
            text-align: left;
            color: #222;
          }
        }

        .svg-icon {
          width: 5px;
          height: 6px;
          margin-left: 10px;
        }
      }

      .news-bottom {
        padding: 16px;

        h2 {
          font-family: NotoSansCJKTC;
          font-weight: bold;
          line-height: 1.75;
          letter-spacing: 0.6px;
        }

        .news-bottom-left {
          width: 264px;
          margin-right: 27px;

          h2 {
            border-bottom: 1px solid #fff;
            padding-bottom: 10px;
            margin-bottom: 10px;
          }

          time {
            font-family: NotoSansCJKTC;
            font-weight: bold;
            line-height: 2;
            letter-spacing: 0.5px;
          }

          h3 {
            font-family: NotoSansCJKTC;
            line-height: 1.67;
            letter-spacing: 0.6px;
            margin-top: -1px;
            height: 40px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }
      }
    }

    .policy {
      position: relative;

      .more {
        padding: 10px 30px;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
        border-width: 2px;
        border-radius: 20px;
        margin-top: 15px;
        margin-bottom: 0;

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 0.8px;
          color: #630106;
        }

        .svg-icon {
          width: 5.1px;
          height: 10.1px;
        }
      }
    }

    .hot-topic {
      margin: 10px;

      .news-item {
        padding: 13px 8px 12px 13px;
        background-color: #fff;
        margin-top: 10px;

        img {
          width: 97px;
          height: 95px;
          object-fit: cover;
          margin-right: 15px;
        }

        time {
          font-family: NotoSansCJKTC;
          font-size: 11px;
          font-weight: bold;
          line-height: 1.73;
          letter-spacing: 0.55px;
        }

        h3 {
          margin-top: 5px;
        }
      }
    }
  }

  .loading-tips {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #AEAEB2;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    padding: 20px;
  }
}
</style>
<style>
.index .swiper-box .swiper-pagination1 {
  position: absolute;
  bottom: 27px;
  z-index: 9;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  justify-content: center;
}

.swiper-box .swiper-pagination-bullet {
  width: 73px;
  height: 2px;
  margin: 0.1px 7px 0;
  opacity: 0.35;
  background-color: #fff;
  border-radius: 0;
}

.swiper-box .swiper-pagination-bullet-active {
  opacity: 1;
}

@media screen and (max-width: 768px) {
  .index .swiper-box .swiper-pagination1 {
    bottom: 12px;
  }

  .swiper-box .swiper-pagination-bullet {
    width: 33px;
    height: 1px;
    margin: 0 3px 0;
    opacity: 0.35;
    background-color: #fff;
    border-radius: 0;
  }

  .swiper-box .swiper-pagination-bullet-active {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue